// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1x48s","label":"Labeled_label__B3ZBH","divider":"Labeled_divider__2OSPH"};